import type { EventFilter, TelemetryEvent } from './types';

/** Drops `type === 'error'` events when `suppress` is true; otherwise a no-op. */
export function suppressErrorEvents<T extends TelemetryEvent>(suppress: boolean | undefined): EventFilter<T> {
  return (event) => event.type !== 'error' || !suppress;
}
